/** @format */

const SearchboxTranslations = {
  en: {
    'Searchbox.header.message1': 'Need ',
    'Searchbox.header.message2': 'help',
    'Searchbox.header.message3': '?',

    'Searchbox.input1': 'Type ',
    'Searchbox.input2': 'what',
    'Searchbox.input3': ' you are looking for:',
    'Searchbox.input.placeholder': 'Type here...',

    'Searchbox.select.categories1': 'Select a ',
    'Searchbox.select.categories2': 'category',
    'Searchbox.select.categories3': ':',

    'Searchbox.button': 'Search',
  },

  it: {
    'Searchbox.header.message1': 'Serve ',
    'Searchbox.header.message2': 'aiuto',
    'Searchbox.header.message3': '?',

    'Searchbox.input1': 'Scrivi ',
    'Searchbox.input2': 'cosa',
    'Searchbox.input3': ' stai cercando:',
    'Searchbox.input.placeholder': 'Scrivi qui...',

    'Searchbox.select.categories1': 'Seleziona una ',
    'Searchbox.select.categories2': 'categoria',
    'Searchbox.select.categories3': ':',

    'Searchbox.button': 'Cerca',
  },
};

export default SearchboxTranslations;
